import {RoleEnum} from "~/types/User";

export interface TabItem {
    role: RoleEnum[],
    path: string;
    icon: string | null;
    iconSvg?: string;
    name: string;
    child_pages: string[];
    show_in_mobile: boolean,
    show_in_desktop: boolean,
    isPrivate: boolean,
}

export function useNavTabs() {
    const config = useRuntimeConfig();
    const { resolve } = useRouter();

    const navTabs = ref<TabItem[]>([
        {
            role: [RoleEnum.MASTER, RoleEnum.CUSTOMER],
            name: 'My tasks',
            icon: 'ri:dashboard-line',
            path: resolve({ name: "office" }).path,
            child_pages: [],
            show_in_mobile: true,
            show_in_desktop: true,
            isPrivate: true,
        },
        {
            role: [RoleEnum.CUSTOMER],
            name: 'Home',
            icon: 'ri:home-6-line',
            path: '/',
            child_pages: [],
            show_in_mobile: true,
            show_in_desktop: false,
            isPrivate: false,
        },
        {
            role: [RoleEnum.MASTER, RoleEnum.CUSTOMER],
            name: 'Chats',
            icon: 'ri:chat-3-line',
            path: resolve({ name: "office_chats" }).path,
            child_pages: [],
            show_in_mobile: true,
            show_in_desktop: true,
            isPrivate: true,
        },
        {
            role: [RoleEnum.MASTER],
            name: 'Task Search',
            icon: 'ri:search-2-line',
            path: resolve({ name: "office_task_search" }).path,
            child_pages: [],
            show_in_mobile: true,
            show_in_desktop: true,
            isPrivate: true,
        },
        {
            role: [RoleEnum.MASTER, RoleEnum.CUSTOMER],
            name: 'Task archive',
            icon: 'ri:archive-line',
            path: resolve({ name: "office_task_archive" }).path,
            child_pages: [],
            show_in_mobile: true,
            show_in_desktop: true,
            isPrivate: true,
        },
        {
            role: [RoleEnum.MASTER, RoleEnum.CUSTOMER],
            name: 'My profile',
            icon: 'ri:user-3-line',
            path: resolve({ name: "office_profile" }).path,
            child_pages: [
                resolve({ name: "office_profile_notification_settings" }).path,
                resolve({ name: "office_profile_privacy_security" }).path,
                /* '/master-office/profile/billing' */],
            show_in_mobile: true,
            show_in_desktop: true,
            isPrivate: true,
        },
        {
            role: [RoleEnum.MASTER],
            name: 'Portfolio',
            icon: 'ri:grid-line',
            path: resolve({ name: "office_portfolio" }).path,
            child_pages: [],
            show_in_mobile: false,
            show_in_desktop: true,
            isPrivate: true,
        },
        ])

    if(!config.public.isProduction){
        navTabs.value.push({
            role: [RoleEnum.MASTER, RoleEnum.CUSTOMER],
            name: 'JobToken',
            icon: 'custom:jobtoken-outline-1',
            path: resolve({ name: "office_jobtoken" }).path,
            child_pages: [],
            show_in_mobile: false,
            show_in_desktop: true,
            isPrivate: true,
        })
    }

    return navTabs
}